//  ----------      START   IMPORT  BLOCK       ----------
import { useParams } from 'react-router-dom';
import DocsContainer from '../DocsLayout/DocsContainer';
import BaseLayout from '../BaseLayout/BaseLayout';
import { getAboutContents } from './AboutContent';
//  Context
import { useLanguage } from '../../../../../API/Context/LanguageContext';
//  Config
import { FRONTEND_ROUTES } from '../../../../../ConfigFiles/Routes/frontend_routes';
//  ----------      END   IMPORT  BLOCK       ----------


function AboutBasePage({  }) {
  const { lan } = useLanguage()
  const { sectionId } = useParams();
  const content = getAboutContents(lan);

  return (
    <BaseLayout>
      <DocsContainer sections={content} basePath={FRONTEND_ROUTES.static_about}/>
    </BaseLayout>
  );
}

export default AboutBasePage;
